import { Injectable } from '@angular/core';

function getWindow(): Window {
    return window;
}

@Injectable({
    providedIn: 'root'
})
export class WindowReferenceService {
    get nativeWindow() {
        return getWindow();
    }
}

